/** @format */

import { createReducer, on } from '@ngrx/store';
import {
	initialState,
	PayPeriodEntry,
	TimesheetEntryType,
	TimeEntry,
	DailyTimeEntry,
	DailyTimeEntryDetails,
	DaysWorkedCounter,
	CalendarDayEntry,
	DaysOfTheWeek,
	WorkWeekPredictedPattern,
	CDOTemplate,
	PayPeriodWeekNumber,
	ApplicationState,
	CalendarMonthlyEntry,
	ModifiedDurationDayTemplate,
	ExceptionType,
	TimeEntryStatus,
	User,
	TeamMemberProfile,
	ManagerEmployeeTimesheetView,
	TimesheetMetadata,
	TimesheetEntry2,
	Timesheet,
	UserTimesheet,
} from './application.state';

import {
	GenerateCalendarData,
	GetProfileSuccess,
	LoadNextYear,
	LoadPreviousYear,
	SetProfilePicture,
	LoadStaticDataSuccess,
	GetTimeBanksSuccess,
	PostTimeEntriesSuccess,
	SubmitTimeEntries,
	LoadStaticData,
	GetNotificationsSuccess,
	GetAllTimesheetsSuccess,
	GetAllTimesheetsError,
	GetEmployeeTimesheetsSuccess,
	GetAllPayPeriodDataSuccess,
	GetAllPayPeriodDataError,
	StartApplication,
	GetScheduledActingAssignmentsSuccess,
	GetScheduledActingAssignmentsError,
	GetAllScheduledActingAssignmentsSuccess,
	GetAllScheduledActingAssignmentsError,
	GetApprovedTimesheetsSuccess,
	GetApprovedTimesheetsError,
	SetApprovedTeamProfile,
	ClearTeamProfile,
	GetUserDelegationsSuccess,
	GetUserDelegationsError,
	GetTimesheetHistorySuccess,
	GetTimesheetHistoryError,
	ClearTimesheetHistory,
	AddUserImages,
	SetTeamProfileBulk,
	SaveMemberProfileSuccess,
	GetTimeEntriesSuccess,
	GetTimeEntriesError,
	UpdateMemberProfileSuccess,
	SetAllUsers,
} from './application.action';

import { StatCalculatorService, StatHoliday } from 'src/app/services';
import { Configuration } from 'src/app/models/profile';
import * as HelperFunctions from 'src/assets/helper-functions/helper-functions';
import { Profile } from 'src/app/models/profile';
import { SafeUrl } from '@angular/platform-browser';

export const applicationReducer = createReducer(
	initialState,
	// on(GenerateCalendarData, (state, action) => {

	//   const payPeriodEntries = HelperFunctions.expandPayPeriodEntries(action.payPeriodEntries, state.exceptionTypes);
	//   const directEmployeeTimesheetsWithPredictions: ManagerEmployeeTimesheetView[] = state.directEmployeeTimesheets.map(submission => {
	//     return {
	//       ...submission,
	//       timesheets: HelperFunctions.timesheetProjection(state.payPeriods, state.statHolidaysMap, state.profile, submission.timesheets)
	//     }
	//   })

	//   return {
	//     ...state,
	//     // payPeriodEntries: payPeriodEntries,
	//     // calendarEntries: convertToCalendarEntries(payPeriodEntries, state),
	//     timesheets: HelperFunctions.timesheetProjection(state.payPeriods, state.statHolidaysMap, state.profile, state.timesheets),
	//     isLoadingData: false,
	//     directEmployeeTimesheets: directEmployeeTimesheetsWithPredictions
	//   };
	// }),

	on(StartApplication, (state) => {
		const directEmployeeTimesheetsWithPredictions: ManagerEmployeeTimesheetView[] = state.directEmployeeTimesheets.map((submission) => {
			return {
				...submission,
				timesheets: HelperFunctions.timesheetProjection(
					state.payPeriods,
					state.statHolidaysMap,
					state.profile,
					submission.timesheets,
					state.userScheduledActingAssignments,
					submission.active
				),
			};
		});

		return {
			...state,
			timesheets: HelperFunctions.timesheetProjection(
				state.payPeriods,
				state.statHolidaysMap,
				state.profile,
				state.rawTimesheets,
				state.userScheduledActingAssignments
			),
			isLoadingData: false,
			directEmployeeTimesheets: directEmployeeTimesheetsWithPredictions,
		};
	}),

	on(GetAllTimesheetsSuccess, (state, action) => {
		return {
			...state,
			timesheets: HelperFunctions.timesheetProjection(
				state.payPeriodEntries,
				state.statHolidaysMap,
				state.profile,
				action.timesheets,
				state.userScheduledActingAssignments
			),
			rawTimesheets: action.timesheets,
			initialLoadingState: {
				...state.initialLoadingState,
				isTimesheetsLoaded: true,
			},
		};
	}),

	on(GetAllTimesheetsError, (state) => {
		return {
			...state,
			timesheets: [],
		};
	}),

	on(GetTimesheetHistorySuccess, (state, action) => {
		const timesheetHistory: Timesheet[] = (action.success as Timesheet[]).map((t) => HelperFunctions.parseLoadedTimesheet(t));

		return {
			...state,
			timesheetHistory,
		};
	}),

	on(ClearTimesheetHistory, (state) => {
		return {
			...state,
			timesheetHistory: [],
		};
	}),

	on(GetTimesheetHistoryError, (state) => {
		return {
			...state,
			timesheetHistory: [],
		};
	}),

	on(AddUserImages, (state, action) => {
		return {
			...state,
			userImages: Object.assign({}, state.userImages, action.userImages),
		};
	}),

	on(GetAllScheduledActingAssignmentsSuccess, (state, action) => {
		return {
			...state,
			allScheduledActingAssignments: action.scheduledActingAssignments,
			userScheduledActingAssignments: action.scheduledActingAssignments.filter((saa) => saa.forUserId === state.profile.user.id),
			timesheets: HelperFunctions.timesheetProjection(
				state.payPeriods,
				state.statHolidaysMap,
				state.profile,
				state.rawTimesheets,
				action.scheduledActingAssignments.filter((saa) => saa.forUserId === state.profile.user.id)
			),
		};
	}),

	on(GetAllScheduledActingAssignmentsError, (state) => {
		return {
			...state,
			allScheduledActingAssignments: [],
		};
	}),

	on(GetScheduledActingAssignmentsSuccess, (state, action) => {
		return {
			...state,
			userScheduledActingAssignments: action.scheduledActingAssignments,
			initialLoadingState: {
				...state.initialLoadingState,
				isScheduledActingsLoaded: true,
			},
		};
	}),

	on(GetScheduledActingAssignmentsError, (state) => {
		return {
			...state,
			userScheduledActingAssignments: [],
		};
	}),

	on(GetUserDelegationsSuccess, (state, action) => {
		return {
			...state,
			userDelegationEntries: action.delegations,
		};
	}),

	on(GetUserDelegationsError, (state) => {
		return {
			...state,
			userDelegationEntries: [],
		};
	}),

	on(GetApprovedTimesheetsSuccess, (state, action) => {
		const approvedTimesheets = action.timesheets.map((t) => {
			return Object.assign({}, t, {
				configurations: parseConfiguration(t.configurations),
			});
		});

		const allTimesheets = action.allTimesheets.map((t) => {
			return Object.assign({}, t, {
				configurations: parseConfiguration(t.configurations),
			});
		});

		return {
			...state,
			approvedTimesheets,
			allUserTimesheets: HelperFunctions.allUserTimesheetProjections(
				allTimesheets,
				state.payPeriods,
				state.statHolidaysMap,
				action.actingAssignments
			),
		};
	}),

	on(GetApprovedTimesheetsError, (state) => {
		return {
			...state,
			approvedTimesheets: [],
			allUserTimesheets: [],
		};
	}),

	on(GetEmployeeTimesheetsSuccess, (state, action) => {
		const pts = parseTimesheets(action.submissions);

		const directEmployeeTimesheetsWithPredictions: ManagerEmployeeTimesheetView[] = pts.map((submission: ManagerEmployeeTimesheetView) => {
			const customProfile = HelperFunctions.getBlankConfigurationProfile(submission.configurations);

			return {
				...submission,
				timesheets: HelperFunctions.timesheetProjection(
					state.payPeriods,
					state.statHolidaysMap,
					customProfile,
					submission.timesheets,
					state.userScheduledActingAssignments,
					submission.active
				),
			};
		});
		return {
			...state,
			directEmployeeTimesheets: directEmployeeTimesheetsWithPredictions, // parseTimesheetsAndProject(action.submissions, state)
		};
	}),

	on(GetTimeEntriesSuccess, (state, action) => {
		return {
			...state,
			timeEntries: action.timeEntries,
		};
	}),

	on(GetTimeEntriesError, (state) => {
		return {
			...state,
			timeEntries: [],
		};
	}),

	on(GetAllPayPeriodDataSuccess, (state, action) => {
		return {
			...state,
			payPeriods: action.payPeriods,
			initialLoadingState: {
				...state.initialLoadingState,
				isPayPeriodsLoaded: true,
			},
		};
	}),

	on(GetAllPayPeriodDataError, (state) => {
		return {
			...state,
			payPeriods: [],
		};
	}),

	on(GetProfileSuccess, (state, { profile }) => {
		const today = new Date(); // HelperFunctions.convertToYYYYMMDD(new Date());
		const parsedProfile: Profile = parseProfile(profile);
		const configurationAsOfToday = HelperFunctions.configurationOn(parsedProfile.configuration, today);

		return {
			...state,
			profile: parsedProfile,
			// profileConfigurationMap,
			isUserCDOEnrolled: configurationAsOfToday.cdo,
			cdoTemplateInfo: setCDOTemplate(parsedProfile), // TODO confirm when this is used - might need to calculate dynamically
			regularHourDuration: configurationAsOfToday.durationOfRegularDay,
			modifiedDayDurationTemplate: setModifiedDurationHoursTemplate(parsedProfile), // TODO confirm when this is used - might need to calculate dynamically
			initialLoadingState: {
				...state.initialLoadingState,
				isProfileLoaded: true,
			},
		};
	}),

	on(SetAllUsers, (state, action) => {
		return {
			...state,
			allUsers: action.allUsers,
		};
	}),

	on(SetProfilePicture, (state, action) => {
		const profilePicture = setProfilePicture(state, action.pictureBlob);
		const userImages = Object.assign({}, state.userImages, {});
		userImages[state.profile.user.upn] = profilePicture!;
		return {
			...state,
			profilePicture,
			userImages,
		};
	}),

	// on(SetTeamProfile, (state, action) => ({
	//   ...state,
	//   teamProfile: appendTeamMember(state, action.pic, action.email)
	// })),

	on(SetTeamProfileBulk, (state, action) => {
		const userImages = Object.assign({}, state.userImages);
		action.userImages.forEach((u) => {
			userImages[u.email] = u.profilePic!;
		});

		return {
			...state,
			teamProfile: Object.assign([], action.userImages),
			userImages,
		};
	}),

	on(SetApprovedTeamProfile, (state, action) => ({
		...state,
		teamProfile: appendTeamMember(state, action.pic, action.email, 'approvedTS'),
	})),

	on(ClearTeamProfile, (state) => ({
		...state,
		teamProfile: [],
	})),

	on(LoadNextYear, (state) => ({
		...state,
		selectedYear: state.selectedYear + 1,
	})),

	on(LoadPreviousYear, (state) => ({
		...state,
		selectedYear: state.selectedYear - 1,
	})),

	on(LoadStaticData, (state) => ({
		...state,
		isLoadingData: true,
	})),

	on(LoadStaticDataSuccess, (state, action) => {
		const yearsArr: number[] = [];

		action.response.stat.forEach((stat: any) => {
			let year = new Date(stat.date).getFullYear();
			if (!yearsArr.includes(year)) yearsArr.push(year);
		});

		let statHolidaysArr: StatHoliday[] = [];
		let statService = new StatCalculatorService();
		yearsArr.forEach((year) => {
			statHolidaysArr.push(...statService.getStatHolidays(year));
		});

		const statHolidays: any = statHolidaysArr.map((s: any) => ({
			name: s.name,
			date: new Date(s.date),
			observedDate: new Date(s.observedDate),
		}));
		const statHolidaysMap = statHolidays.reduce(
			(previousState: { [id: string]: StatHoliday }, current: StatHoliday): { [id: string]: StatHoliday } => {
				previousState[HelperFunctions.convertToYYYYMMDD(current.observedDate)] = current;
				return previousState;
			},
			{}
		);
		return {
			...state,
			statHolidays,
			statHolidaysMap,
			bankTypes: action.response.static.bankTypes,
			exceptionTypes: action.response.static.exceptionTypes,
			exceptionTypesMap: Object.assign(
				{},
				...action.response.static.exceptionTypes.map((e: ExceptionType) => ({
					[e.id]: e,
				}))
			),
			projects: action.response.static.projects,
			notificationTypes: action.response.static.reminderTypes,
			updateReasons: action.response.static.updateReasons,
			initialLoadingState: {
				...state.initialLoadingState,
				isStatHolidaysLoaded: true,
			},
			systemUser: action.response.static.systemUser,
		};
	}),
	// })),
	on(GetTimeBanksSuccess, (state, payload) => ({
		...state,
		timeBank: payload.timeBank,
	})),

	on(PostTimeEntriesSuccess, (state, action) => {
		const payPeriodEntries = updatedPayPeriodEntries(state.payPeriodEntries, action.action, state.exceptionTypesMap);
		const calendarEntries = convertToCalendarEntries(payPeriodEntries, state);
		// calendarEntries: convertToCalendarEntries(action.payPeriodEntries, state)
		// calendarEntries: convertToCalendarEntries([], state)
		return {
			...state,
			payPeriodEntries,
			calendarEntries,
		};
	}),
	on(GetNotificationsSuccess, (state, payload) => ({
		...state,
		notifications: payload.notifications,
	})),

	on(SaveMemberProfileSuccess, (state, payload) => ({
		...state,
		profile: Object.assign({}, state.profile, {
			manage: payload.manage,
		}),
	})),

	on(UpdateMemberProfileSuccess, (state, payload) => ({
		...state,
		profile: {
			...state.profile,
			manage: payload.manage,
		},
	}))
);

const parseTimesheets = (submissions: ManagerEmployeeTimesheetView[]): ManagerEmployeeTimesheetView[] => {
	return submissions.map((submission) => {
		const parsedTimesheets = submission.timesheets.map((timesheet) => {
			const parsedEntries: TimesheetEntry2[] = JSON.parse(timesheet.entries.toString());
			const parsedMetadata: TimesheetMetadata[] = JSON.parse(timesheet.metadata.toString());

			const parsedTimesheet: Timesheet = {
				...timesheet,
				entries: parsedEntries,
				metadata: parsedMetadata,
			};
			parsedTimesheet.startDate = new Date(parsedTimesheet.startDate);
			parsedTimesheet.endDate = new Date(parsedTimesheet.endDate);
			return parsedTimesheet;
		});
		return {
			...submission,
			timesheets: parsedTimesheets,
		};
	});
};

// const parseTimesheetsAndProject = (submissions: ManagerEmployeeTimesheetView[], state: ApplicationState): ManagerEmployeeTimesheetView[] => {
//   return submissions.map(submission => {
//     const parsedTimesheets = submission.timesheets.map(timesheet => {
//       const parsedEntries: TimesheetEntry2[] = JSON.parse(timesheet.entries.toString());
//       const parsedMetadata: TimesheetMetadata[] = JSON.parse(timesheet.metadata.toString());

//       const parsedTimesheet: Timesheet = {
//         ...timesheet,
//         entries: parsedEntries,
//         metadata: parsedMetadata
//       }
//       parsedTimesheet.startDate = new Date(parsedTimesheet.startDate);
//       parsedTimesheet.endDate = new Date(parsedTimesheet.endDate);
//       return parsedTimesheet
//     })
//     const parsedSubmission: ManagerEmployeeTimesheetView = {
//       ...submission,
//       timesheets: HelperFunctions.timesheetProjection(state.payPeriodEntries, state.statHolidaysMap, state.profile, parsedTimesheets, state.userScheduledActingAssignments)
//     }
//     return parsedSubmission;
//   })
// }

const parseProfile = (profile: Profile) => {
	return Object.assign({}, profile, {
		configuration: parseConfiguration(profile.configuration),
	});
};

const parseConfiguration = (configurations: Configuration[]) => {
	return configurations.map((c) => {
		return Object.assign({}, c, {
			createdAt: HelperFunctions.getFutureDate(c.createdAt, 0),
			startingDate: HelperFunctions.getFutureDate(c.startingDate, 0),
		});
	});
};

const setProfilePicture = (state: ApplicationState, pictureBlob: Blob | null) => {
	if (pictureBlob) {
		return pictureBlob;
	} else {
		return profilePictureUrlLookup(state.profile.user);
	}
};

const profilePictureUrlLookup = (user: User) => {
	let url: string | null;
	switch (user.upn) {
		case 'AutomatedTesting1@dnv.org':
			url = '/assets/images/AutomatedTesting1.jpg';
			break;

		case 'AutomatedTesting2@dnv.org':
			url = '/assets/images/AutomatedTesting2.jpg';
			break;

		case 'AutomatedTesting3@dnv.org':
			url = '/assets/images/AutomatedTesting3.jpg';
			break;

		case 'timesheet@dnv.org':
			url = '/assets/images/SystemAccount.png';
			break;

		default:
			url = null;
			break;
	}
	return url;
};

///
const updatedPayPeriodEntries = (
	payPeriodEntries: PayPeriodEntry[],
	action: any,
	exceptionTypesMap: { [id: number]: ExceptionType }
): PayPeriodEntry[] => {
	const payPeriodId = action.yyyyppww.slice(0, 6);
	const weekOfPayPeriod = parseInt(action.yyyyppww.slice(6));

	const payPeriodEntryIndex = payPeriodEntries.findIndex((ppe) => ppe.payPeriod === payPeriodId);
	if (payPeriodEntryIndex < 0) {
		return payPeriodEntries;
	}

	const payPeriodToUpdate = payPeriodEntries[payPeriodEntryIndex];

	const newStatus = action.type === SubmitTimeEntries.type ? TimeEntryStatus.Submitted : TimeEntryStatus.Saved;

	let updatedPayPeriod: PayPeriodEntry;
	if (1 === weekOfPayPeriod) {
		updatedPayPeriod = HelperFunctions.updateTimeEntryInWeekOneOfPayPeriod(payPeriodToUpdate, action, newStatus, exceptionTypesMap);
	} else {
		updatedPayPeriod = HelperFunctions.updateTimeEntryInWeekTwoOfPayPeriod(payPeriodToUpdate, action, newStatus, exceptionTypesMap);
	}

	// // add entryDate
	// const timeEntries = action.timeEntries.map((timeEntry:any) => ({
	//   ...timeEntry,
	//   entries: addDateToTimeEntries(timeEntry.entries, payPeriodToUpdate.startDate)
	// })
	// );

	// const updatedPayPeriod = payPeriodEntries[payPeriodEntryIndex];

	return [...payPeriodEntries.slice(0, payPeriodEntryIndex), updatedPayPeriod, ...payPeriodEntries.slice(payPeriodEntryIndex + 1)];
};

// const addDateToTimeEntries = (timeEntries: TimeEntryDetails[], startDate: string | Date ) => {

//   return timeEntries.map((e, i) => {
//     return {
//       ...e,
//       entryDate: HelperFunctions.getFutureDate(startDate, i)
//     }

//   })
//   // let date = HelperFunctions.getFutureDate(startDate, i);
// }

///

// functions to handle generating the calendar object
let isUserCDOEnrolled = false;
let cdoTemplateInfo: CDOTemplate;
let regularHoursDuration: number;
let modifiedDayDurationTemplate: ModifiedDurationDayTemplate;
let payPeriodIndexCount = 0;
let currentPayPeriod = '';

const predictedWorkWeekPattern: WorkWeekPredictedPattern[] = [
	{ day: DaysOfTheWeek.Sunday, predictedWorkDay: false },
	{ day: DaysOfTheWeek.Monday, predictedWorkDay: false },
	{ day: DaysOfTheWeek.Tuesday, predictedWorkDay: false },
	{ day: DaysOfTheWeek.Wednesday, predictedWorkDay: false },
	{ day: DaysOfTheWeek.Thursday, predictedWorkDay: false },
	{ day: DaysOfTheWeek.Friday, predictedWorkDay: false },
	{ day: DaysOfTheWeek.Saturday, predictedWorkDay: false },
];

const numTimesWorkedPerDay: DaysWorkedCounter[] = [
	{ day: DaysOfTheWeek.Sunday, numberTimesWorked: 0 },
	{ day: DaysOfTheWeek.Monday, numberTimesWorked: 0 },
	{ day: DaysOfTheWeek.Tuesday, numberTimesWorked: 0 },
	{ day: DaysOfTheWeek.Wednesday, numberTimesWorked: 0 },
	{ day: DaysOfTheWeek.Thursday, numberTimesWorked: 0 },
	{ day: DaysOfTheWeek.Friday, numberTimesWorked: 0 },
	{ day: DaysOfTheWeek.Saturday, numberTimesWorked: 0 },
];

const setModifiedDurationHoursTemplate = (profile: Profile): ModifiedDurationDayTemplate => {
	const isCDO = profile.configuration.length > 0 ? HelperFunctions.getCurrentConfiguration(profile.configuration).cdo : false;

	if (!isCDO) {
		return {
			day: DaysOfTheWeek.Unassigned,
			modifiedDayWeek: PayPeriodWeekNumber.Unassigned,
			hours: 0,
		};
	}

	const currentConfig = HelperFunctions.getCurrentConfiguration(profile.configuration);

	const modifiedDayWeek = currentConfig.modifiedDurationDay <= 7 ? PayPeriodWeekNumber.weekOne : PayPeriodWeekNumber.weekTwo;
	const dayToFind = currentConfig.modifiedDurationDay <= 7 ? currentConfig.modifiedDurationDay : currentConfig.modifiedDurationDay - 7;
	const day = HelperFunctions.getDayOfWeekFromNumber(dayToFind);
	return { day, modifiedDayWeek, hours: currentConfig.durationOfModifiedDay };
};

const setCDOTemplate = (profile: Profile): CDOTemplate => {
	const isCDO = profile.configuration.length > 0 ? HelperFunctions.getCurrentConfiguration(profile.configuration).cdo : false;

	if (!isCDO) {
		return {
			day: DaysOfTheWeek.Unassigned,
			cdoWeek: PayPeriodWeekNumber.Unassigned,
		};
	}

	const currentConfig = HelperFunctions.getCurrentConfiguration(profile.configuration);

	const cdoWeek = currentConfig.cdoDay <= 7 ? PayPeriodWeekNumber.weekOne : PayPeriodWeekNumber.weekTwo;
	const dayToFind = currentConfig.cdoDay <= 7 ? currentConfig.cdoDay : currentConfig.cdoDay - 7;
	const day = HelperFunctions.getDayOfWeekFromNumber(dayToFind);

	return { day, cdoWeek };
};

const convertToCalendarEntries = (payPeriodEntries: PayPeriodEntry[], state: ApplicationState) => {
	HelperFunctions.resetWorkWeekCalculationParameters(numTimesWorkedPerDay, predictedWorkWeekPattern);
	HelperFunctions.setWorkWeekPredictionPattern(payPeriodEntries, numTimesWorkedPerDay, predictedWorkWeekPattern);

	payPeriodIndexCount = 0;
	currentPayPeriod = '';

	isUserCDOEnrolled = state.isUserCDOEnrolled;
	cdoTemplateInfo = state.cdoTemplateInfo;
	regularHoursDuration = state.regularHourDuration;
	modifiedDayDurationTemplate = state.modifiedDayDurationTemplate;
	const statHolidays = state.statHolidays;
	const exceptionTypes = state.exceptionTypes;

	const yearsIncludedInEntries: number[] = [];
	const convertedPayPeriodData: CalendarMonthlyEntry[] = [];

	payPeriodEntries.forEach((entry) => {
		const year = (entry.startDate as Date).getFullYear(); //Number(entry.startDate.split("-")[0]);
		if (!yearsIncludedInEntries.includes(year)) {
			yearsIncludedInEntries.push(year);
		}
	});

	if (yearsIncludedInEntries.length === 0) {
		yearsIncludedInEntries.push(state.selectedYear);
	}

	yearsIncludedInEntries.forEach((currentYear) => {
		for (let currentMonth = 0; currentMonth < 12; currentMonth++) {
			const generatedCalenderData = generateMonthlyData(currentYear, currentMonth, payPeriodEntries, statHolidays, exceptionTypes);
			convertedPayPeriodData.push({
				year: currentYear,
				month: currentMonth,
				calendarEntries: generatedCalenderData,
			});
		}
	});

	return convertedPayPeriodData;
};

const generateMonthlyData = (
	currentYear: number,
	currentMonth: number,
	payPeriodEntries: PayPeriodEntry[],
	statHolidays: StatHoliday[],
	exceptionTypes: ExceptionType[]
): CalendarDayEntry[] => {
	const searchMonth = `${currentYear}-${HelperFunctions.convertSingleConstToDoubleDigitStr(currentMonth + 1)}`;
	const relatedPayEntries = payPeriodEntries.filter(
		(payPeriod: PayPeriodEntry) =>
			(payPeriod.startDate as Date).toISOString().includes(searchMonth) || (payPeriod.endDate as Date).toISOString().includes(searchMonth)
	);

	const payDates = payPeriodEntries
		.filter((payPeriod: PayPeriodEntry) => (payPeriod.payDate as Date).toISOString().includes(searchMonth))
		.map((e) => e.payDate);

	const lastDateofLastMonth = new Date(currentYear, currentMonth, 0).getDate();
	const firstDayofMonth = new Date(currentYear, currentMonth, 1).getDay() + 1;
	const lastDateofMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
	const lastDayofMonth = new Date(currentYear, currentMonth, lastDateofMonth).getDay() + 1;

	const dailyTimeEntries = convertToDailyEntries(relatedPayEntries, currentMonth, currentYear, lastDateofMonth, statHolidays, exceptionTypes);
	const calendarEntries: CalendarDayEntry[] = [];

	let currentWeekInMonth = 1;

	// If the week contains days from both months, then fill in empty spaces until then
	if (firstDayofMonth !== 7) {
		// fill in the html to include the previous month up until the start of the current month
		for (let i = firstDayofMonth; i > 0; i--) {
			const entry: CalendarDayEntry = {
				isNeighborMonth: true,
				shouldShowDay: false,
				isPayDay: false,
				isHoliday: false,
				isCDO: false,
				isStat: false,
				isWorkingDay: false,
				isSick: false,
				isOvertime: false,
				dateEntry: lastDateofLastMonth - i + 1,
				payPeriodIndex: -1,
				entryTypeTime: [],
				expectedDailyHours: 0,
				isPredictedData: false,
				isSavedData: false,
				currentWeekInMonth,
				month: currentMonth !== 0 ? currentMonth - 1 : 11,
				year: currentMonth !== 0 ? currentYear : currentYear - 1,
			};

			calendarEntries.push(entry);
		}
	}

	// fill in the dates for the current month
	for (let i = 1; i <= lastDateofMonth; i++) {
		const dayEntry = dailyTimeEntries[i - 1];
		const currentDate = `${currentYear}-${HelperFunctions.convertSingleConstToDoubleDigitStr(
			currentMonth + 1
		)}-${HelperFunctions.convertSingleConstToDoubleDigitStr(i)}`;

		const startDateCompVal = dayEntry && dayEntry.entries.length > 0 ? dayEntry?.entries[0].payPeriodEntry.startDate : currentDate;
		const daysFromPayPeriodStart = HelperFunctions.getDifferenceInDays(startDateCompVal, currentDate);

		const entry: CalendarDayEntry = {
			isNeighborMonth: false,
			shouldShowDay: true,
			isPayDay: payDates.some((payDate) => HelperFunctions.convertToStandardDateString(new Date(payDate)) === currentDate),
			isHoliday: false, // determine in a later step if this is a holiday closure
			isCDO: dayEntry
				? dayEntry.entries.some(
						(entry) => HelperFunctions.getExceptionFromTypeId(entry.exceptionType.id) === TimesheetEntryType.CDO && entry.duration > 0
				  )
				: false,
			isStat:
				dayEntry && dayEntry.entries.length > 0
					? HelperFunctions.isStatHolidayDate(dayEntry.entries[0].payPeriodEntry, daysFromPayPeriodStart, statHolidays)
					: false,
			isSick: dayEntry
				? dayEntry.entries.some(
						(entry) => HelperFunctions.getExceptionFromTypeId(entry.exceptionType.id) === TimesheetEntryType.SICK && entry.duration > 0
				  )
				: false,
			isOvertime: dayEntry
				? dayEntry.entries.some(
						(entry) =>
							HelperFunctions.getExceptionFromTypeId(entry.exceptionType.id) === TimesheetEntryType.OVERTIME && entry.duration > 0
				  )
				: false,
			isWorkingDay: dayEntry
				? dayEntry.entries.some(
						(entry) =>
							HelperFunctions.getExceptionFromTypeId(entry.exceptionType.id) === TimesheetEntryType.REGULAR_DAY && entry.duration > 0
				  )
				: false,
			payPeriodIndex: dayEntry && dayEntry.entries.length > 0 ? dayEntry.entries[0].payPeriodIndex : -1,
			payPeriodInfo: dayEntry && dayEntry.entries.length > 0 ? dayEntry.entries[0].payPeriodEntry : undefined,
			entryTypeTime: HelperFunctions.buildEntryTypeTime(dayEntry),
			expectedDailyHours:
				dayEntry && dayEntry.entries.length > 0
					? HelperFunctions.getExpectedDailyHours(
							predictedWorkWeekPattern,
							dayEntry.entries[0].payPeriodEntry,
							isUserCDOEnrolled,
							cdoTemplateInfo,
							regularHoursDuration,
							modifiedDayDurationTemplate,
							daysFromPayPeriodStart
					  )
					: regularHoursDuration,
			isPredictedData: (dayEntry && dayEntry.entries.length > 0 && !dayEntry.entries.some((entry) => !entry.isPredictedData)) || false,
			isSavedData:
				(dayEntry &&
					!dayEntry.entries.some((entry) => entry.isPredictedData) &&
					!dayEntry.entries.some(
						(entry) => entry.status === 'Submitted' || entry.status === 'Approved' || entry.status === 'Sent to JDE'
					)) ||
				false,

			currentWeekInMonth,
			year: currentYear,
			month: currentMonth,
			dateEntry: i,
		};

		// Assume every non-stat day between christmas and new years is a holiday closure
		if (currentMonth == 11 /*December*/ && i > 26 && i <= 31 && !entry.isStat && (entry.isWorkingDay || entry.isCDO)) {
			entry.isHoliday = true;
		}

		if (entry.isStat) {
			const statEntry = statHolidays.filter((stat) => HelperFunctions.getDifferenceInDays(stat.observedDate.toString(), currentDate) === 0);
			entry.statHolidayName = `${statEntry[0]?.name} (Observed)`;
		}

		const nextDate = HelperFunctions.getFutureDate(currentDate, 1);
		const nextDay = nextDate.getDay();
		if (nextDay === DaysOfTheWeek.Saturday) {
			currentWeekInMonth++;
		}

		calendarEntries.push(entry);
	}

	// fill in the dates for the end of the current month till the end of the week
	const remainingDaysCounter = lastDayofMonth === 7 ? 0 : lastDayofMonth;
	for (let i = remainingDaysCounter; i < 6; i++) {
		const entry: CalendarDayEntry = {
			isNeighborMonth: true,
			shouldShowDay: false,
			isPayDay: false,
			isHoliday: false,
			isCDO: false,
			isStat: false,
			isSick: false,
			isOvertime: false,
			isWorkingDay: false,
			dateEntry: i - remainingDaysCounter + 1,
			payPeriodIndex: -1,
			entryTypeTime: [],
			expectedDailyHours: 0,
			isPredictedData: false,
			isSavedData: false,
			currentWeekInMonth,
			month: currentMonth !== 11 ? currentMonth + 1 : 0,
			year: currentMonth !== 11 ? currentYear : currentYear + 1,
		};

		calendarEntries.push(entry);
	}

	return calendarEntries;
};

const convertToDailyEntries = (
	relatedPayEntries: PayPeriodEntry[],
	currentMonth: number,
	currentYear: number,
	lastDateOfCurrentMonth: number,
	statHolidays: StatHoliday[],
	exceptionTypes: ExceptionType[]
): DailyTimeEntry[] => {
	if (relatedPayEntries.length > 0) {
		const startPayPeriod = relatedPayEntries[0].startDate;
		const monthStartDate = `${currentYear}-${HelperFunctions.convertSingleConstToDoubleDigitStr(currentMonth + 1)}-01`;

		const endPayPeriod = relatedPayEntries[relatedPayEntries.length - 1].endDate;
		const monthEndDate = `${currentYear}-${HelperFunctions.convertSingleConstToDoubleDigitStr(currentMonth + 1)}-${lastDateOfCurrentMonth}`;

		// Set these parameters here so that we only get the data that pertains to the month in question
		let daysTillMonthStart = HelperFunctions.getDifferenceInDays(startPayPeriod, monthStartDate);
		let daysMoreThanMonthEnd = HelperFunctions.getDifferenceInDays(monthEndDate, endPayPeriod);

		const dailyTimeEntries: DailyTimeEntry[] = [];
		let isInitialPayPeriod = true;
		let isIntermediatePayPeriod = false;
		let isFinalPayPeriod = false;
		let numberDailyEntriesToPrepend = 0;

		let entryArrStartingIndex = 0;

		if (daysTillMonthStart < 0) {
			numberDailyEntriesToPrepend = Math.abs(daysTillMonthStart);
			isInitialPayPeriod = false;
			for (let i = 0; i < numberDailyEntriesToPrepend; i++) {
				dailyTimeEntries.push({ entries: [] });
			}

			daysTillMonthStart = 0;
		}

		if (daysMoreThanMonthEnd < 0) {
			daysMoreThanMonthEnd = 0;
		}

		for (let payPeriodIndex = 0; payPeriodIndex < relatedPayEntries.length; payPeriodIndex++) {
			const payPeriodEntry = relatedPayEntries[payPeriodIndex];

			if (currentPayPeriod === '') {
				currentPayPeriod = payPeriodEntry.payPeriod;
			} else {
				if (currentPayPeriod !== payPeriodEntry.payPeriod) {
					currentPayPeriod = payPeriodEntry.payPeriod;
					payPeriodIndexCount++;
				}
			}

			isIntermediatePayPeriod = !isInitialPayPeriod && payPeriodEntry.endDate !== endPayPeriod;
			isFinalPayPeriod = !isInitialPayPeriod && !isIntermediatePayPeriod;

			if (isIntermediatePayPeriod || isFinalPayPeriod) {
				entryArrStartingIndex = dailyTimeEntries.length;
			}

			// let isPredictedData = payPeriodEntry.timeEntry.length === 0;
			const isPredictedData = true;
			const predictedTimeEntries = HelperFunctions.generatePredictedTimesheetData(
				predictedWorkWeekPattern,
				payPeriodEntry,
				statHolidays,
				exceptionTypes,
				isUserCDOEnrolled,
				cdoTemplateInfo,
				regularHoursDuration,
				modifiedDayDurationTemplate
			);

			predictedTimeEntries.forEach((timeSheetEntry) => {
				buildCalendarObjectArr(
					isInitialPayPeriod,
					isIntermediatePayPeriod,
					isFinalPayPeriod,
					daysTillMonthStart,
					daysMoreThanMonthEnd,
					timeSheetEntry,
					dailyTimeEntries,
					payPeriodEntry,
					payPeriodIndexCount,
					entryArrStartingIndex,
					isPredictedData
				);
			});

			isInitialPayPeriod = false;

			// TODO -> check per week if there is time loaded. If no time is loaded, use predicted, not loaded w 0 everywhere...

			const providedTimeEntries = payPeriodEntry.timeEntry;
			providedTimeEntries.forEach((timeEntryType) => {
				timeEntryType.entries.forEach((timeEntry) => {
					const exceptionType = exceptionTypes.find((exType) => exType.id === timeEntryType.exceptionTypeId)!;

					if (timeEntry.entryDate) {
						const entryDate = new Date(timeEntry.entryDate);

						if (
							entryDate.getMonth() === currentMonth &&
							((HelperFunctions.dateIsWithinWeekOneOfPayPeriod(payPeriodEntry, entryDate) &&
								HelperFunctions.timeEntryInWeekOneOfPayPeriod(payPeriodEntry)) ||
								(HelperFunctions.dateIsWithinWeekTwoOfPayPeriod(payPeriodEntry, entryDate) &&
									HelperFunctions.timeEntryInWeekTwoOfPayPeriod(payPeriodEntry)))
						) {
							const dailyEntryIndex = entryDate.getDate() - 1;
							const payPeriodEntry = dailyTimeEntries[dailyEntryIndex].entries[0].payPeriodEntry;
							const payPeriodIndex = dailyTimeEntries[dailyEntryIndex].entries[0].payPeriodIndex;
							const projectId = dailyTimeEntries[dailyEntryIndex].entries[0].projectId;

							const entry = {
								payPeriodEntry,
								payPeriodIndex,
								projectId,
								isPredictedData: false,
								exceptionType,
								...timeEntry,
							};
							if (dailyTimeEntries[dailyEntryIndex].entries.every((e) => e.isPredictedData)) {
								dailyTimeEntries[dailyEntryIndex].entries = [entry];
							} else {
								dailyTimeEntries[dailyEntryIndex].entries.push(entry);
							}
						}
					}
				});
			});
		}

		return dailyTimeEntries;
	}

	return [];
};

const buildCalendarObjectArr = (
	isInitialPayPeriod: boolean,
	isIntermediatePayPeriod: boolean,
	isFinalPayPeriod: boolean,
	daysTillMonthStart: number,
	daysMoreThanMonthEnd: number,
	timeSheetEntry: TimeEntry,
	dailyTimeEntries: DailyTimeEntry[],
	payPeriodEntry: PayPeriodEntry,
	payPeriodIndex: number,
	entryArrStartingIndex: number,
	isPredictedData: boolean
) => {
	if (isInitialPayPeriod) {
		// start the data extraction from the beginning of the month in the entries array till the end
		for (let i = daysTillMonthStart; i < timeSheetEntry.entries.length; i++) {
			const entryDetails = timeSheetEntry.entries[i];
			const entry = HelperFunctions.buildDailyTimeEntryObject(timeSheetEntry, entryDetails, payPeriodEntry, payPeriodIndex, isPredictedData);

			if (dailyTimeEntries[i - daysTillMonthStart]) {
				// handle saving to dailyTimeEntries.entries array
				dailyTimeEntries[i - daysTillMonthStart].entries.push(entry);
			} else {
				const entries: DailyTimeEntryDetails[] = [entry];
				dailyTimeEntries.push({ entries });
			}
		}
	}

	if (isIntermediatePayPeriod) {
		for (let i = 0; i < timeSheetEntry.entries.length; i++) {
			const entryDetails = timeSheetEntry.entries[i];
			const entry = HelperFunctions.buildDailyTimeEntryObject(timeSheetEntry, entryDetails, payPeriodEntry, payPeriodIndex, isPredictedData);

			if (dailyTimeEntries[entryArrStartingIndex + i]) {
				dailyTimeEntries[entryArrStartingIndex + i].entries.push(entry);
			} else {
				const entries: DailyTimeEntryDetails[] = [entry];
				dailyTimeEntries.push({ entries });
			}
		}
	}

	if (isFinalPayPeriod) {
		for (let i = 0; i < timeSheetEntry.entries.length - daysMoreThanMonthEnd; i++) {
			const entryDetails = timeSheetEntry.entries[i];
			const entry = HelperFunctions.buildDailyTimeEntryObject(timeSheetEntry, entryDetails, payPeriodEntry, payPeriodIndex, isPredictedData);

			if (dailyTimeEntries[entryArrStartingIndex + i]) {
				dailyTimeEntries[entryArrStartingIndex + i].entries.push(entry);
			} else {
				const entries: DailyTimeEntryDetails[] = [entry];
				dailyTimeEntries.push({ entries });
			}
		}
	}
};

const appendTeamMember = (state: ApplicationState, teamPic: SafeUrl | null, email: string, type = 'managerTS') => {
	let teamMember: ManagerEmployeeTimesheetView[] | UserTimesheet[] = [];
	if (type === 'managerTS') {
		teamMember = state.directEmployeeTimesheets.filter((ee) => ee.employeeEmail === email);
	} else if (type === 'approvedTS') {
		teamMember = state.approvedTimesheets.filter((ee) => ee.employeeEmail === email);
	}

	if (teamMember.length > 0) {
		let testProfile = null;
		if (teamMember[0].employeeEmail.toLowerCase().indexOf('automatedtesting') > -1) {
			const user = {
				upn: teamMember[0].employeeEmail,
			} as unknown as User;
			testProfile = profilePictureUrlLookup(user);
		}
		const member: TeamMemberProfile = {
			// lastName: teamMember[0].employeeLastName,
			// firstName: teamMember[0].employeeFirstName,
			email: teamMember[0].employeeEmail,
			profilePic: teamPic ? teamPic : testProfile,
		};

		const memberExists = state.teamProfile.findIndex((t) => t.email === email);
		if (memberExists === -1) {
			return [...state.teamProfile, member];
		}
	}
	return state.teamProfile;
};
